const Month3 = [
    {id: "1", value: "1個月"},    
    {id: "2", value: "2個月"},
    {id: "3", value: "3個月"}
  ];  
  
  export default Month3  